export default __webpack_public_path__ + "static/media/Logo Menu.708bb996.png";